import {SET_PROVIDER, Web3ActionTypes} from '../../types/actions/Web3.actions';
import {BrowserProvider} from 'ethers';

export const setProvider = (
  provider: BrowserProvider,
): Web3ActionTypes => ({
  type: SET_PROVIDER,
  payload: {provider},
});
